import { Rectangle, type Container } from 'pixi.js';

/**
 * A token answers the pointer on its own footprint only (issue 1079). At fit-to-screen a square is about 23 px and
 * the nameplate, drawn below the token, lies over the neighbouring square; since issue 1030 draws a smaller token over a
 * bigger one, a right-click on the big token opened the small neighbour's menu. The hit area prunes the whole node —
 * plate, overlays, marks — outside the footprint (Pixi tests a container's `hitArea` before its children), and the
 * plate itself takes no pointer at all. The overlays' hover tips still answer inside the footprint.
 */
export function limitHitToFootprint(node: Container, width: number, height: number): void {
  const a = node.hitArea;
  if (a instanceof Rectangle) { a.x = 0; a.y = 0; a.width = width; a.height = height; }
  else node.hitArea = new Rectangle(0, 0, width, height);
  const plate = node.getChildByLabel('name');
  if (plate) plate.eventMode = 'none';
}
